export default "__VITE_ASSET__D3G8oTyT__"